// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"9ef719f6","46":"7fa5cf59","111":"164f4583","340":"1ef43165","346":"32778a2c","506":"17dac194","784":"1027b92b","963":"f3bb1022"}[chunkId] + ".chunk.js";
};